import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  exceedMaxLength: 'This field should contain 1 - 256 characters',
})
